<template>
    <router-link 
        :to="{
                name: 'proyecto_zona', 
                params:{url:post.url}
            }" 
        >
       <slot />
    </router-link>
</template>
<script>
export default {
    props:['post']
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/proyectosLink.vue